module.exports = __webpack_public_path__ + "img/comment-xmark-duotone.acc37f7a.svg";